angular.module('satv.track')
    .factory('TrackNoteFormModal', ['config', 'Modal', function (config, Modal) {
        'use strict';
        return {
            open: function (params, data) {
                return Modal.create(
                    config.templateRoot + '/templates/smf/modals/track-note-form',
                    params,
                    data
                );
            }
        };
    }]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/services/TrackNoteFormModal.js